export enum LessonCompletionFlags {
  CompleteAtEnd = 0x0000,
  CompleteAtThreshold = 0x0001
}

interface LessonNativeSettings {
  completionFlags: LessonCompletionFlags;
  threshold: number;
  singleAttemptPerVersion: boolean;
}

export default LessonNativeSettings;
